module.exports = __webpack_public_path__ + "img/26_27.2f597b86.png";